export const GITHUB_REPO = {
  owner: 'evanpurkhiser',
  repo: 'prolink-tools',
};

export const GITHUB_REPO_URL = `https://github.com/${GITHUB_REPO.owner}/${GITHUB_REPO.repo}`;

export const WEBSERVER_PORT = 5152;

/**
 * The API version identifies the apps protocol to the API server at app
 * registration time. If the server does not support this API version the client
 * will not be able to connected.
 */
export const LATEST_API_VERSION = 0;
